import React from "react";
import Typography from "material-ui/Typography";
import Grid from "material-ui/Grid";
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "material-ui/Table";
import Button from "material-ui/Button";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
import Icon from "material-ui/Icon";
import { metersToFeet } from "../../../../../common/utils";
import SignaltekThumbnailViewer from "../../thumbnails/signaltekThumbnail";
class SignaltekSummaryResult extends React.Component {
  constructor(props) {
    super(props);

    let subtests = [];
    // for (var item in props.results.data.subtests) {
    //   subtests.push({ type: item });
    // }
    if (props.results.data.qualification) {
      subtests.push({ type: "qualification" });
      if (props.impersonating) {
        subtests.push({ type: "qualification_il" });
        subtests.push({ type: "qualification_rl" });
        subtests.push({ type: "qualification_next" });
      }
    }
    else if (props.results.data.wiremap) subtests.push({ type: "wiremap" });
    if (props.results.data.poeload) subtests.push({ type: "poeload" });
    if (props.results.data.fiberlengthloss) subtests.push({ type: "fiberlengthloss" });
    if (props.results.data.ping4) subtests.push({ type: "ping4" });
    if (props.results.data.ping6) subtests.push({ type: "ping6" });
    if (props.results.data.traceroute4) subtests.push({ type: "traceroute4" });
    if (props.results.data.traceroute6) subtests.push({ type: "traceroute6" });
    if (props.results.data.netscan) subtests.push({ type: "netscan" });
    if (props.results.data.maxthroughput)
      subtests.push({ type: "maxthroughput" });
    if (props.results.data.uptime) subtests.push({ type: "uptime" });
    if (props.results.data.customdata) subtests.push({ type: "customdata" });
    if (props.results.data.cabledata) subtests.push({ type: "cabledata" });
    if (props.results.data.webdata) subtests.push({ type: "webdata" });
    if (props.results.data.voipdata) subtests.push({ type: "voipdata" });
    if (props.results.data.videodata) subtests.push({ type: "videodata" });
    if (props.results.data.cctvdata) subtests.push({ type: "cctvdata" });
    if (!props.results.data.qualification) {
      if (
        subtests.length > 1 &&
        props.results.data.subtests.hasOwnProperty("stats")
      )
        subtests.push({ type: "stats" });
      else if (
        subtests.length == 1 &&
        subtests[0].type != "wiremap" &&
        props.results.data.subtests.hasOwnProperty("stats")
      )
        subtests.push({ type: "stats" });
    }

    this.state = {
      showAll: false,
      subtests: subtests
    };
    this.toggleShowAll = this.toggleShowAll.bind(this);
  }

  render() {
    const {
      classes,
      translate,
      job,
      results,
      getSubtestResults,
      pager,
      showMargin,
      setPreferences,
      preferences,
      onChangeResultsViewer,
      chartMeasurementUnit
    } = this.props;
    const { subtests } = this.state;
    let subtest = [];

    let testInterface = translate("create_signaltek_copper")
    if (results.data.maininterface === "Optical") {
      testInterface = translate("result_optical")
    }
    else if (results.data.maininterface === "WiFi") {
      testInterface = translate("WiFi")
    }
    if (results) {
      return (
        <Grid container className={classes.resultsViewer}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Grid container xs={12} className={classes.testInfo}>
              <Grid item xs={2}>
                <span>
                  <Typography type="subheading" className={classes.testDetails}>
                    <strong>{translate("job_engineer")}</strong>
                    {results.data.engineer ? ": " + results.data.engineer : ":"}
                  </Typography>
                </span>
              </Grid>
              <Grid item xs={4}>
                <Typography type="subheading" className={classes.testDetails}>
                  <strong>{translate("job_device")}</strong>
                  {": " + results.data.device}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography type="subheading" className={classes.testDetails}>
                  <strong>
                    { (job.deviceid === "signaltek10g") ? translate("result_main") +
                      " " +
                      translate("testinterface") : translate("testinterface") }
                  </strong>

                  {": " + testInterface}
                </Typography>
              </Grid>
              {(job.deviceid === "signaltek10g") && (
              <Grid item xs={2}>
                <Typography type="subheading" className={classes.testDetails}>
                  <strong>
                    {translate("result_remote") +
                      " " +
                      translate("testinterface")}
                  </strong>

                  {results.data.remoteinterface &&
                  results.data.remoteinterface.length > 0
                    ? results.data.remoteinterface == "Eth"
                      ? ": " + translate("create_signaltek_copper")
                      : ": " + translate("result_optical")
                    : ": -"}
                </Typography>
              </Grid>
              )}
              <Grid item xs={2}>
                {job.deviceid === "signaltek10g" ?
                <Typography type="subheading" className={classes.testDetails}>
                  <strong>{translate("operationmode")}</strong>
                  {": " + this.getOperationModeString(results.data.operationmodebitmap)}
                </Typography> : ""
                }
              </Grid>
            </Grid>
            <Grid container>
              {subtests.map(test => {
                // if (
                //   results.data.devicetype === "LantekIII" ||
                //   results.data.devicetype === "Comet"
                // )
                return (
                  <SignaltekThumbnailViewer
                    translate={translate}
                    subtest={test.type}
                    job={job}
                    //graphable={test.graph}
                    results={results}
                    pager={pager}
                    getSubtestResults={getSubtestResults}
                    // subtestResultsRemote={subtestResultsRemote}
                    // subtestResultsDisplay={subtestResultsDisplay}
                    // subtestResultsWiremap={subtestResultsWiremap}
                    // chartLineStyle={chartLineStyle}
                    //chartMeasurement={chartMeasurement}
                    chartMeasurementUnit={chartMeasurementUnit}
                    // wiremapStandard={wiremapStandard}
                    showMargin={showMargin}
                    setPreferences={setPreferences}
                    preferences={preferences}
                    onChangeResultsViewer={onChangeResultsViewer}
                  />
                );
              })}
            </Grid>
          </Grid>
        </Grid>
      );
    } else {
      return <Typography type="button">No data</Typography>;
    }
  }

  toggleShowAll() {
    this.setState({
      showAll: !this.state.showAll
    });
  }

  getOperationModeString(bitmap) {
    const { translate } = this.props;
    if (bitmap === 0) {
      return translate("advancedmode")
    }
    if ((bitmap === undefined) || (bitmap === null) || ((bitmap & 0xf) != 1)) {
      return "-";
    }
    const separator = " / ";
    const basicModeType = (bitmap >> 4) & 0xf;
    var operationMode = translate("basicmode");
    switch(basicModeType) {
      case 0: operationMode += separator + translate("qualifycable");
              return operationMode;
      case 1: operationMode += separator + translate("networktest");
              break;
      default: return operationMode;
    }
    const networkTestType = (bitmap >> 8) & 0xff;
    switch (networkTestType) {
      case 0: operationMode += separator + "IP";
              break;
      case 1: operationMode += separator + translate("bandwidth");
              break;
      case 2: operationMode += separator + translate("ip_bandwidth");
              break;
      default: return operationMode;
    }
    const testModeType = (bitmap >> 16) & 0xff;
    switch (testModeType) {
      case 0: operationMode += separator + translate("autotest");
              break;
      case 1: operationMode += separator + translate("manualtest");
              break;
      default: break;
    }
    return operationMode;
  }

  getMeasurements() {
    const { results, translate, chartMeasurementUnit } = this.props;
    const subtests = [];
    const measurements = [];
    let val = "";
    if (results) {
      let summaries = [
        ...results.data.subtests,
        ...results.data.othersubtests
      ].sort((x, y) => {
        if (x.order < y.order) return -1;
        if (x.order > y.order) return 1;
        return 0;
      });

      summaries.map(measurement => {
        if (measurement.margin) {
          val = measurement.unit
            ? measurement.margin.value !== null
              ? `${measurement.margin.value} ${measurement.unit}`
              : ""
            : "";
          measurements.push({
            measurement: translate(measurement.subtesttype),
            margin: measurement.margin
              ? `${measurement.margin.margin} ${
                  measurement.unit ? measurement.unit : ""
                } / Pair ${measurement.margin.pair} | ${
                  measurement.margin.handsettype
                }`
              : "",
            value: val,
            subteststatus:
              measurement.subteststatus === "Pass" ? (
                <Icon>check_circle</Icon>
              ) : (
                <Icon>cancel</Icon>
              ),
            show: measurement.isdefault,
            hidden: measurement.hidden
          });
          subtests.push({
            type: measurement.subtesttype
          });
        } else {
          val = measurement.unit
            ? measurement.worst && measurement.worst.value !== null
              ? `${measurement.worst.value} ${measurement.unit}`
              : ""
            : "";
          if (
            measurement.subtesttype === "Length" &&
            chartMeasurementUnit === "feet" &&
            measurement.worst.value
          ) {
            val = metersToFeet(measurement.worst.value);
          }
          measurements.push({
            measurement: translate(measurement.subtesttype),
            margin: measurement.worst
              ? `${
                  measurement.worst && measurement.worst.pair
                    ? `Pair ${measurement.worst.pair}`
                    : ""
                }`
              : "",
            value: val,
            subteststatus:
              measurement.subteststatus === "Pass" ? (
                <Icon>check_circle</Icon>
              ) : (
                <Icon>cancel</Icon>
              ),
            show: measurement.isdefault,
            hidden: measurement.hidden
          });
        }
        return null;
      });
    }
    return {
      measurements,
      subtests
    };
  }
}

export default withStyles(styles)(SignaltekSummaryResult);
